// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__H5SGS","container__title":"styles_container__title__Aq4SO","skeleton-animation":"styles_skeleton-animation__TGdw3"};